<template>
  <v-sheet width="100%"  class="ma-2" >
    <div id="heatmap-container" style="width: 95%; min-height: 500px; margin: 0 auto;"></div>
  </v-sheet>
</template>

<script>
import Highcharts from "highcharts";
import HighchartsHeatmap from "highcharts/modules/heatmap";
import HighchartsExporting from "highcharts/modules/exporting";

HighchartsHeatmap(Highcharts);
HighchartsExporting(Highcharts);

export default {
  name: "PhenotypeHallmark",
  props: {
    tdata: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      heatmapData: [],
      categoriesX: [],
      categoriesY: [],
      chart: null,
    };
  },
  methods: {
    processplot(){
      if (this.tdata.length > 0) {
        this.processData(this.tdata);
        this.$nextTick(() => this.renderHeatmap());
      }
    },
    processData(rawData) {
      this.categoriesX = [...new Set(rawData.map((d) => d.phenotype.replace("HALLMARK_", "")))]
          .sort((a, b) => a.localeCompare(b));
      this.categoriesY = [...new Set(rawData.map((d) => d.cancer_type))];
      this.heatmapData = rawData.map((item) => {
        const xIndex = this.categoriesX.indexOf(item.phenotype.replace("HALLMARK_", ""));
        const yIndex = this.categoriesY.indexOf(item.cancer_type);
        const ptm_pval = Math.abs(item.pheno_ptm_pvalue);

        let stars = "";
        if (ptm_pval < 0.001) stars = "***";
        else if (ptm_pval < 0.01) stars = "**";
        else if (ptm_pval < 0.05) stars = "*";

        return {
          x: xIndex,
          y: yIndex,
          value: item.pheno_ptm_val,
          pval: ptm_pval,
          stars: stars,
          protein: item.harm_protein,
          site: item.harm_site,
          phenotype: item.phenotype,
        };
      });
    },
    renderHeatmap() {
      const container = document.getElementById("heatmap-container");
      if (!container) return;

      if (this.chart) {
        if (this.resizeListener) {
          window.removeEventListener("resize", this.resizeListener);
          this.resizeListener = null;
        }
        this.chart.destroy();
        this.chart = null;
      }

      this.chart = Highcharts.chart(container, {
        chart: {
          type: "heatmap",
          plotBorderWidth: 0.2,
          reflow: true
        },
        title: { text: "PTM-Phenotype Heatmap Across Different Cancer Cohorts", align: "center" },
        xAxis: {
          categories: this.categoriesX,
          title: { text: "Phenotype", style: { fontSize: "1rem", color: "black" } },
          labels: {
            rotation: -45,
            overflow: "justify",
            crop: false,
            align: "right",
            style: { fontSize: "12px" },
            step: 1 },
        },
        yAxis: {
          categories: this.categoriesY,
          title: { text: "Cancer Type", style: { fontSize: "1rem", color: "black" } },
        },
        colorAxis: {
          stops: [
            [0, "#B71C1C"], [0.2, "#C62828"], [0.4, "#FAFAFA"],
            [0.6, "#FAFAFA"], [0.8, "#2962FF"], [1, "#1E88E5"],
          ],
          min: -1,
          max: 1,
          tickPositions: [1, 0.4, 0.2, -0.2, -0.4, -1],
        },
        legend: {
          align: "right",
          layout: "vertical",
          verticalAlign: "top",
          x: -20,
          y: 80,
          symbolHeight: 120,
        },
        tooltip: {
          formatter() {
            return `<b>Cancer Type:</b> ${this.series.yAxis.categories[this.point.y]}<br>
                    <b>Phenotype:</b> ${this.series.xAxis.categories[this.point.x]}<br>
                    <b>Correlation value:</b> ${this.point.value}<br>
                    <b>p-value:</b> ${this.point.pval}`;
          },
        },
        series: [
          {
            name: "Phenotype Heatmap",
            borderWidth: 0.5,
            borderColor: "#FFFFFF",
            data: this.heatmapData,
            dataLabels: {
              enabled: true,
              color: "#000000",
              formatter() {
                return this.point.stars || "";
              },
            },
            point:{
              events: {
                click: function () {
                  const url = `https://kb.linkedomics.org/plot/phospho?protein=${this.protein}&site=${this.site}&cohort=${this.series.yAxis.categories[this.y]}&phenotype=${this.phenotype}`;
                  window.open(url, '_blank');
                }
              }
            }
          },
        ],
        exporting: {
          enabled: true,
          scale:4,
          chartOptions: {
            chart: {
              width: document.getElementById('heatmap-container').offsetWidth,
              height: document.getElementById('heatmap-container').offsetHeight,
            },
          },
          buttons: {
            contextButton: {
              menuItems: ['downloadPNG',  'downloadSVG']
            }
          }
        }
      });

    },
  },
  mounted() {
    this.processplot()
  },
  beforeDestroy() {

    if (this.chart) {
      this.chart.destroy();
      this.chart = null;
    }
  }
};
</script>

<style scoped>
#heatmap-container {
  margin: 0 auto;
}
</style>
